import styles from './Loader.module.css';

function Loader() {
  return <p className={styles.text}>Loading movies, please wait...</p>;
}

export default Loader;
